module.exports = __webpack_public_path__ + "img/login-cb-logo.e47fa0d2.svg";